import { observer } from 'mobx-react';
import classNames from 'classnames';
import { useStore } from '../../core/utils/hook';
import { useEffect, useState } from 'react';
import { MSG } from '../../core/configs/constants';
import yup from '../../core/utils/yupValidate';
import { useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import ReactNotifications from '../../components/Notifications/ReactNotifications';

import './styles.scss';
import { useNavigate } from 'react-router-dom';

export default observer(function EditDropAddressScreen() {

    // other
    const navigate = useNavigate();

    // store
    const { authStore: { changeEmail }, 
        generalStore: { exchanges, tokens, getAllExchanges, getAllTokens },
        userStore: { dropAddresses, getDropAddresses, updateDropAddresses, setAttrObservable }
    } = useStore();

    // state
    const [mapTokenEx, setMapTokenEx] = useState(new Map());

    const validateSchema = yup.object().shape({
        dropAddresses: yup.array().of(yup.object({
            tokenId: yup
                .string()
                .required(MSG['error.required']),
            exchangeId: yup
                .string()
                .required(MSG['error.required']),
            dropAddress: yup
                .string()
                .trim()
                .required(MSG['error.required']),
            note: yup.string().trim().nullable()
        })).nullable().notRequired().default([])
    })
    
    const { 
        register, 
        handleSubmit, 
        watch,
        setValue,
        formState: { errors, isSubmitting },
        control
    } = useForm({resolver: yupResolver(validateSchema), defaultValues: {
        dropAddresses: []
    }, mode: 'onChange'});

    const { fields, append, remove, update } = useFieldArray({
        control,
        name: 'dropAddresses'
    });

    const watchDropAddresses = watch('dropAddresses');

    // life cycle
    useEffect(() => {
        getDropAddresses();
        getAllExchanges({ size: -1, sortDir: 'asc', sortKey: 'id' });
        getAllTokens({ size: -1, sortDir: 'asc', sortKey: 'id' });

        return () => {
            setAttrObservable('dropAddresses', []);
        }
    }, []);

    useEffect(() => {
        if (dropAddresses?.length && exchanges?.length && tokens?.length) {
            convertDataDropAddresses(dropAddresses || []);
        }

    }, [dropAddresses, exchanges, tokens])

    // function
    const convertDataDropAddresses = (dropAddresses) => {
        let cvDropAddreses = [...dropAddresses] || [];
                
        if (cvDropAddreses && cvDropAddreses.length) {
            let mapTokenList = new Map();
            cvDropAddreses.forEach((da, index) => {
                let filterToken = tokens.filter(t => t.exchanges.some(e => e.exchangeId == da.exchangeId));

                if (!filterToken.some(t => t.id == da.tokenId)) {
                    console.log(filterToken, da)
                    cvDropAddreses[index].tokenId = null;
                }

                mapTokenList.set(index, filterToken)
            })

            setMapTokenEx(mapTokenList);
        }

        
        setValue('dropAddresses', cvDropAddreses)
    }

    const addExchangeAndTokenDefault = () => {
        let exchangeId =  exchanges?.length ? exchanges?.[0]?.id : null;

        let defaultObj = {}

        if (exchangeId) {
            defaultObj.exchangeId = exchangeId;
            let filterToken = tokens.filter(t => t.exchanges.some(e => e.exchangeId == exchangeId));
            if (filterToken.length) {
                defaultObj.tokenId = filterToken[0]?.id
            }
            
            setMapTokenEx(prev => {
                let newMap = new Map(prev);
                newMap.set(watchDropAddresses?.length || 0, filterToken)

                return newMap;
            })
        } else {
            setMapTokenEx(prev => {
                let newMap = new Map(prev);
                newMap.set(watchDropAddresses?.length || 0, [])

                return newMap;
            })
        }

        append(defaultObj);
        
    }

    const onChangeExchange = (exchangeId, index) => {
        let tokenFilter = tokens.filter(t => t.exchanges.some(e => e.exchangeId == exchangeId)) || [];
        let tokenDefaultId = null;
        if (tokenFilter.length) {
            tokenDefaultId =  tokenFilter?.[0]?.id
        }

        setMapTokenEx(prev => {
            let newMap = new Map(prev);
            newMap.set(index, tokenFilter)

            return newMap;
        })

        setValue(`dropAddresses.${index}.exchangeId`, exchangeId); 
        setValue(`dropAddresses.${index}.tokenId`, tokenDefaultId);
    }

    const onRemoveDropID = (id) => {
        remove(id);
    }

    const onSubmit = async ( data ) => {
        const res = await updateDropAddresses(data);
        if (res) {
            // navigate('/account');
            getDropAddresses();
            ReactNotifications('success', MSG['inform.success.update']);
        }
    }

    return (
        <div className='edit-drop-address border-radius-10 bg-cs-container min-height-820'>
            <div className='fs-heading-large font-semi-bold'>Drop先アドレス編集</div>
            <form onSubmit={handleSubmit(onSubmit)} className='mg-t-15'>
                {
                    fields?.length > 0 && fields.map((field, index) => {
                        const tokenOptions = mapTokenEx?.get(index);

                        return <div key={field.id} className='dropaddress-token border-bottom'>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='fs-heading-normal font-semi-bold'>{`Drop先アドレス ${index + 1}`}</div>
                                <div>
                                    <button 
                                        type='button'
                                        className='btn btn-bg-cs-down text-color-cs-white width-100 btn-common' 
                                        onClick={() => {onRemoveDropID(index)}}>削除</button>
                                </div>
                            </div>
                            <div className='row mg-t-25 align-items-start'>
                                <label className='col-3 fs-default font-medium text-color-cs-8 pd-none'>
                                    アドレス <span className='text-color-cs-red'>*</span>
                                </label>
                                <div className='col-9'>
                                    <input 
                                        className='input-type-2 text-color-cs-white font-medium fs-label reset-auto-fill w-100'
                                        {...register(`dropAddresses.${index}.dropAddress`)}
                                        maxLength={255}
                                        type='text'
                                        autoComplete='off'/>
                                    {
                                        errors.dropAddresses && errors.dropAddresses[index] &&
                                        <div className='text-danger mg-t-5 fs-error'>{errors.dropAddresses[index]?.dropAddress?.message}</div>
                                    }
                                </div>
                            </div>
                            <div className='row mg-t-25 align-items-start'>
                                <label 
                                    className='col-3 fs-default font-medium text-color-cs-8 pd-none'>
                                        取引所 <span className='text-color-cs-red'>*</span>
                                </label>
                                <div className='col-9'>
                                    <select {...register(`dropAddresses.${index}.exchangeId`)} 
                                        onChange={(e) => onChangeExchange(e.target.value, index)}
                                        className='w-100 font-medium fs-label input-type-2 reset-auto-fill height-35'>
                                        {
                                            exchanges?.length > 0 &&
                                            exchanges.map(e =>
                                                <option key={e?.id} value={e?.id} >{e?.name}</option>
                                            )
                                        }
                                    </select>
                                    {
                                        errors.dropAddresses && errors.dropAddresses[index] &&
                                <div className='text-danger mg-t-5 fs-error'>{errors.dropAddresses[index]?.exchangeId?.message}</div>
                                    }
                                </div>
                            </div>
                            <div className='row mg-t-25 align-items-start'>
                                <label 
                                    className='col-3 fs-default font-medium text-color-cs-8 pd-none'>
                            トークン <span className='text-color-cs-red'>*</span>
                                </label>
                                <div className='col-9 text-color-cs-white font-medium fs-label'>
                                    <select {...register(`dropAddresses.${index}.tokenId`)} 
                                        className='w-100 font-medium input-type-2 fs-label reset-auto-fill height-35'>
                                        {
                                            tokenOptions?.length > 0 &&
                                            tokenOptions.map(e =>
                                                <option key={e?.id} value={e?.id} >{e?.name}</option>
                                            )
                                        }
                                    </select>
                                    {
                                        errors.dropAddresses && errors.dropAddresses[index] &&
                                <div className='text-danger mg-t-5 fs-error'>{errors.dropAddresses[index]?.tokenId?.message}</div>
                                    }
                                </div>
                            </div>
                            <div className='row mg-t-25 align-items-start'>
                                <label className='col-3 fs-default font-medium text-color-cs-8 pd-none'>メモ</label>
                                <div className='col-9 text-color-cs-white font-medium fs-label'>
                                    <textarea 
                                        className='input-type-2 w-100 reset-auto-fill' 
                                        {...register(`dropAddresses.${index}.note`)}
                                        maxLength={1000}
                                        autoComplete='off'/>
                                    {
                                        errors.dropAddresses && errors.dropAddresses[index] &&
                                <div className='text-danger mg-t-5 fs-error'>{errors.dropAddresses[index]?.note?.message}</div>
                                    }
                                </div>
                            </div>
                        </div>
                    })
                }
                <div className='d-flex item-border-bottom align-items-center width-230 height-50 mg-t-20' 
                    role='button' 
                    onClick={() => {
                        addExchangeAndTokenDefault();
                    }
                    }>
                    <i className="fa-solid text-color-cs-1 mg-r-5 fa-circle-plus fs-heading-normal" />
                    <span className='fs-label font-medium text-color-cs-1'>Drop先アドレスを追加する</span>
                </div>
                <div className='row mg-t-50'>
                    {/* <div className='col-3'></div> */}
                    <div className='droppaddress-button col-12 d-flex justify-content-center'>
                        <button 
                            type='button'
                            className='btn btn-cs-1 text-color-cs-white width-150 btn-common' 
                            onClick={() => {navigate('/account')}}>キャンセル</button>
                        <button type='submit' className='btn btn-bg-cs-1 width-150 btn-common' disabled={isSubmitting}>変更</button>
                    </div>
                </div>
            </form>
        </div>
    );
});

